import Header from "../../shared/FanHeader/header";
import Footer from "../../shared/footer/footer";
import AboutComponent from "../../shared/about/aboutComponent";

const FanAbout = () => {
	return (
		<div>
			<Header />
			<AboutComponent />
			<Footer />
		</div>
	);
};

export default FanAbout;
